export default __webpack_public_path__ + "static/media/CarImages.SonetMedium1.6a5868a9.jpg";